/** @prettier */

import {useEffect, useState} from 'react';

//API import
import {
  getStatesSitesSl,
  getCompositionsGroups,
} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';

/**
 * ユニット単位の状態値を画面読み込み時と、1分ごとに取得するフック
 * @param siteId サイトID
 * @returns ユニット毎の状態値データ
 */
export const useUnitStates = (siteId: string) => {
  /** 状態値 */
  const [unitsData, setUnitsData] = useState<apiIF.resParameters.slStates[]>(
    []
  );
  /** グループの情報 */
  const [groupData, setGroupData] = useState<
    apiIF.resParameters.groupInformations[]
  >([]);

  //最新状態値取得（消費電力量以外）
  useEffect(() => {
    const reqStatesUnit = () => {
      getStatesSitesSl(siteId, {
        fields:
          'unit-name,floor,run-stop,error-code,operation-mode,indoor-temperature,preset-temperature',
      })
        .then(response => {
          //最新の稼働状況データ (配列の先頭が最新データ)
          setUnitsData(response['sl-states'][0]['states']);
        })
        .catch(err => {});
      getCompositionsGroups(siteId, {
        'fields':
          'group-name,floor,unit-system,group-authority,unit-informations',
        'max-result': 400,
      }).then(response => {
        setGroupData(
          response['group-informations'].filter(
            info => info['unit-system'] === 'SL'
          )
        );
      });
    };

    //ページ遷移時初回読み込み
    reqStatesUnit();
    //定期実行
    const intervalId = setInterval(() => {
      reqStatesUnit();
    }, 60000);

    return function () {
      clearInterval(intervalId);
    };
  }, [siteId]);

  return {unitsData, groupData};
};
